'use client';

import classNames from 'classnames';
import React from 'react';

import { useStore } from '@/helpers/store';

export const Background: React.FC = () => {
  const backgroundColor = useStore((state) => state.backgroundColor);

  const backgroundClass = classNames({
    'bg-airtime': backgroundColor === 'mmhmm',
    // Bentoville spotlight now uses the dark background
    'bg-bentoville2': backgroundColor === 'bentoville1',
    'bg-carrot-dark': backgroundColor === 'carrot',
    'bg-sora': backgroundColor === 'sora',
    'bg-partners': backgroundColor === 'partners',
    'bg-white': backgroundColor === 'white' || !backgroundColor,
  });

  React.useEffect(() => {
    const highlightSection = document.querySelector('#highlight-section');
    if (!highlightSection) {
      return;
    }

    highlightSection.classList.remove(
      'bg-airtime',
      'bg-bentoville1',
      'bg-bentoville2',
      'bg-carrot-dark',
      'bg-sora',
      'bg-partners',
      'bg-white',
    );
    highlightSection.classList.add(backgroundClass);
  }, [backgroundClass]);

  return null;
};
